import { useEffect, useState } from "react";
import { useI18n } from "@/i18n";

// Dotsero AI launcher — sits right of the global search, sized to the ⌘K field (h-7).
// Dark mode: black tile, light ring + blue dot. Light mode: flipped (white tile, black ring). Hover / chat-open: subtle sky tint.
export function DotseroButton({ className = "" }) {
  const { t } = useI18n();
  const [active, setActive] = useState(false);
  useEffect(() => {
    const on = () => setActive(true), off = () => setActive(false);
    window.addEventListener("mira:opened", on);
    window.addEventListener("mira:closed", off);
    return () => { window.removeEventListener("mira:opened", on); window.removeEventListener("mira:closed", off); };
  }, []);
  const tone = active
    ? "bg-[#e9f7fe] border-sky-300 dark:bg-sky-500/15 dark:border-sky-400/50"
    : "bg-[#ffffff] border-[#e2e8f0] hover:bg-[#e9f7fe] hover:border-sky-300 dark:bg-[#0a0a0a] dark:border-white/10 dark:hover:bg-sky-500/15 dark:hover:border-sky-400/50";
  const tailFill = active
    ? "fill-[#e9f7fe] dark:fill-[#0f1d26]"
    : "fill-[#ffffff] group-hover:fill-[#e9f7fe] dark:fill-[#0a0a0a] dark:group-hover:fill-[#0f1d26]";
  const tailStroke = active
    ? "stroke-sky-300 dark:stroke-sky-400/50"
    : "stroke-[#e2e8f0] group-hover:stroke-sky-300 dark:stroke-white/10 dark:group-hover:stroke-sky-400/50";
  return (
    <button
      type="button"
      onClick={() => window.dispatchEvent(new CustomEvent("mira:toggle"))}
      title={t("Dotsero AI — chat")}
      aria-label={t("Open Dotsero AI chat")}
      aria-pressed={active}
      className={`group relative inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-md border transition-[background-color,border-color,transform] duration-150 active:scale-95 ${tone} ${className}`}
      data-testid="dotsero-ai-button"
      data-state={active ? "active" : "default"}
    >
      <img src="/abs-mark-black.png" alt="" className="h-[18px] w-auto select-none dark:hidden" draggable={false} />
      <img src="/abs-mark-white.png" alt="" className="hidden h-[18px] w-auto select-none opacity-80 dark:block" draggable={false} />
      {/* speech-bubble tail hanging below the bottom-right corner — box size unchanged */}
      <svg aria-hidden="true" viewBox="0 0 10 7" className="pointer-events-none absolute -bottom-[6px] right-[4px] h-[7px] w-[10px] overflow-visible">
        <path d="M0 -1 H10 V7 Z" className={tailFill} />
        <path d="M10 0 V7 L0 0" fill="none" strokeWidth="1" strokeLinejoin="miter" className={tailStroke} />
      </svg>
    </button>
  );
}

export default DotseroButton;
